import { kebabCase } from 'lodash';
import Vue from 'vue';

Vue.mixin({
    filters: {
        kebabCase(value) {
            return kebabCase(value);
        },
    },
    methods: {
        kebabCase(value) {
            return kebabCase(value);
        },
    },
});
